import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface VenueHoursProps {
  band: Band
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const VenueHours: React.FC<VenueHoursProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { hours: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { hours: data.additional_info?.hours || null },
    })) as ApiResponse
  }

  const fieldData = {
    field: "additional_info.hours",
    name: "venueHours",
    label: "Hours",
    placeholder: "e.g., open during shows only",
    required: false,
  }

  return (
    <EditBandFormField
      type="text"
      fieldData={fieldData}
      bandId={band.id}
      onSubmit={customOnSubmit}
    />
  )
}

